<template>
    <div>
        <!-- <crud-table :actions="actions" show-search search-placeholder="ابحث باسم الدورة" server-pagination :page-count="lectures.meta.last_page" :current-page="lectures.meta.current_page" :total="lectures.meta.total" :per-page="lectures.meta.per_page" title="الدورات" :items="lecturesItemsComputed" :headers="headers" @edit="openEditDialog" @delete="openDeleteDialog" @load="loadMore" @create="createDialog =  true" @search="search" @hide="openHideDialog" @unhide="openUnhideDialog" @feature="openFeatureDialog" @unfeature="openUnfeatureDialog" @reset="reset" /> -->
        <v-card class="soft-shadow pa-lg-3 mb-4 mb-lg-6">
            <v-card-text >
                <div class="d-flex justify-space-between">
                    <div class="pa-1">
                        <div class="mb-2 d-flex align-center">
                            <h2 class="strong-text--text font-weight-medium" style="line-height: 1">{{lectureData.name}}</h2>
                            <div class="teachers ms-3 d-flex">
                                <div>
                                    <v-chip v-if="lectureData.visibility === 'hidden'" label small color="text" dark class="px-2 me-2" @click="unhideDialog = true">
                                        <v-icon size="16" class="me-2">mdi-eye-off</v-icon>
                                        <span>مخفي</span>
                                    </v-chip>

                                    <v-chip v-if="lectureData.visibility === 'default'" label small color="blue-grey" dark class="px-2 me-2" @click="hideDialog = true">
                                        <v-icon size="16" class="me-2">mdi-eye</v-icon>
                                        <span>افتراضي</span>
                                    </v-chip>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex align-center">
                            <h3 v-if="lectureData.course.pay_type === 'lectures'" class="primary--text">{{moneyFormat(lectureData.price)}}</h3>

                            <div v-if="lectureData.expiry_days" class="ms-3 error--text">
                                أيام انتهاء الصلاحية: <b>{{lectureData.expiry_days}}</b>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex align-center">
                        <v-tooltip v-if="purchases" transition="fade-transition" bottom max-width="280" color="tooltip" :close-delay="300" open-on-focus>
                            <template v-slot:activator="{on, attrs}">
                                <v-btn color="success darken-1" depressed v-on="on" v-bind="attrs" @click="exportAbsentUsersDialog = true" style="height: 38px" class="me-2 px-3">
                                    <v-icon size="22" left>mdi-file-export-outline</v-icon>
                                    <span>استخراج الغياب</span>
                                </v-btn>
                            </template>
                            <span>استخراج غياب الطلاب إلى ملف إكسيل</span>
                        </v-tooltip>
                        <v-btn :icon="phoneOnly" text dense class="px-2" :to="`/courses/${lectureData.course.id}`">
                            <span v-if="pcOnly">{{lectureData.course.name}}</span>
                            <v-icon :right="pcOnly">mdi-arrow-left</v-icon>
                        </v-btn>
                    </div>
                </div>
                
                <v-row v-if="stats" class="mt-5">
                    <v-col cols="12" lg="3">
                        <stat-card label="الفيديوهات" dense flat :value="stats.videos" color="deep-orange" icon="mdi-play-box-multiple"/>
                    </v-col>
                    <v-col cols="12" lg="3">
                        <stat-card label="عمليات الشراء" dense flat :value="stats.purchases" color="success" icon="mdi-order-bool-descending-variant"/>
                    </v-col>
                    <v-col cols="12" lg="3">
                        <stat-card label="المبيعات" dense money flat :value="stats.sales" color="orange" icon="mdi-cash-multiple"/>
                    </v-col>
                    <v-col cols="12" lg="3">
                        <stat-card label="بطاقات الدفع" dense flat :value="stats.paycards" color="primary" icon="mdi-credit-card-multiple-outline"/>
                    </v-col>
                </v-row>

            </v-card-text>
        </v-card>


        <!-- <v-row class="my-2">
            <v-col cols="12" lg="4">
                <stat-card label="الطلاب المشتركون" :value="lectureData.users_count" color="primary" icon="mdi-account-group"/>
            </v-col>
            <v-col cols="12" lg="4">
                <stat-card label="المحاضرات" :value="lectureData.videos_count" color="deep-purple" icon="mdi-human-male-board"/>
            </v-col>
            <v-col cols="12" lg="4">
                <stat-card label="الفيديوهات" :value="lectureData.videos_count" color="deep-orange" icon="mdi-play-box-multiple"/>
            </v-col>
        </v-row> -->

        <!-- <v-card class="soft-shadow pa-3 pt-0 mb-4">
            <v-card-title>اﻹحصائيات</v-card-title>
            <v-card-subtitle>إحصائيات وأرقام استُنتجت من تحليل بيانات الدورة</v-card-subtitle>
            <v-card-text>

            </v-card-text>
        </v-card> -->

        <videos :videos="videos" :page_url="page_url" :lecture_id="id" @loadMore="loadMore" />

        <v-card class="soft-shadow px-lg-3 my-4 my-lg-6">
            <v-card-title class="d-flex justify-space-between align-center mb-1">
                <div>
                    <v-icon color="strong-text" class="me-1">mdi-clipboard-text-multiple-outline</v-icon>
                    الامتحانات</div>
                <div class="actions">
                    <v-btn color="primary" @click="addExamsDialog = true">
                        <v-icon size="20" left>mdi-clipboard-text-outline</v-icon>
                        إضافة امتحان
                    </v-btn>
                </div>
            </v-card-title>
            <v-card-text class="pb-1" :class="{'px-0': phoneOnly}">
                <v-divider></v-divider>

                <!-- <v-divider ></v-divider> -->

                <v-list v-if="lectureExams && lectureExams.length" two-line class="pa-0 mb-3">
                    <template v-for="(exam, i) in lectureExams">
                        <v-list-item :key="exam.id" v-ripple="phoneOnly" @click.prevent="$router.push(`/exams/${exam.id}`)">
                            <v-list-item-icon style="align-self: center">
                                <v-icon color="strong-text">mdi-clipboard-text-outline</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>{{exam.name}}</v-list-item-title>
                                <v-list-item-subtitle>
                                    <v-chip v-if="exam.must_pass" small label color="success darken-1" outlined class="me-2" style="height: 22px">
                                        <v-icon small left class="me-1">mdi-license</v-icon>
                                        النجاح مطلوب
                                    </v-chip>
                                    <v-chip v-else-if="exam.must_take" color="strong-text" outlined small label class="me-2" style="height: 22px">
                                        <v-icon left>mdi-login</v-icon>
                                        دخول الامتحان مطلوب
                                    </v-chip>
                                    <v-chip v-if="exam.alternative_exam" color="error" small label :to="`/exams/${exam.alternative_exam.id}`" class="me-2" @mousedown.stop @mouseover.stop @touchstart.stop @click.stop style="height: 22px">
                                        <v-icon size="16" left>mdi-reload</v-icon>
                                        {{exam.alternative_exam.name}}
                                    </v-chip>
                                    <v-chip v-else label color="grey lighten-4" small class="me-2" style="height: 22px">
                                        <span>لا يوجد امتحان بديل</span>
                                    </v-chip>
                                </v-list-item-subtitle>
                            </v-list-item-content>
                            <v-list-item-icon>
                                <v-btn icon color="primary" @mousedown.stop @mouseover.stop @touchstart.stop @click.stop="openEditExamDialog(exam)">
                                    <v-icon size="22">mdi-cog</v-icon>
                                </v-btn>
                                <v-btn icon color="error" @mousedown.stop @mouseover.stop @touchstart.stop @click.stop="openRemoveExamDialog(exam)">
                                    <v-icon size="22">mdi-close-circle-outline</v-icon>
                                </v-btn>
                            </v-list-item-icon>
                        </v-list-item>

                        <v-divider v-if="i < lectureExams.length-1" :key="'divider-' + i"></v-divider>
                    </template>
                </v-list>

                <div v-else class="py-2">
                    <v-alert text type="info" color="blue-grey darken-1">
                        لا يوجد امتحانات مرتبطة بهذه المحاضرة، أضف امتحان اﻵن!
                    </v-alert>
                </div>
            </v-card-text>
        </v-card>


        <v-card class="soft-shadow px-lg-3 mb-4 mb-lg-6">
            <v-card-title class="d-flex justify-space-between align-center mb-1">
                <div class="d-flex align-center">
                    <v-icon class="me-1">mdi-paperclip</v-icon>
                    المُرفقات
                </div>
                <div class="actions">
                    <v-btn color="primary" @click="addAttachmentDialog = true">
                        <v-icon size="20" left>mdi-paperclip</v-icon>
                        إضافة مُرفق
                    </v-btn>
                </div>
            </v-card-title>
            <v-card-text class="pb-1" :class="{'px-0': phoneOnly}">

                <!-- <v-divider ></v-divider> -->

                <v-list v-if="lectureAttachments && lectureAttachments.length" two-line class="pa-0 mb-3">
                    <template v-for="(attachment, i) in lectureAttachments">
                        <v-list-item :key="attachment.id">
                            <v-list-item-icon>
                                <v-icon color="strong-text">mdi-paperclip</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>{{attachment.name}}</v-list-item-title>
                                <v-list-item-subtitle>
                                    <v-chip dark :color="attachment.meta.extension === 'pdf' ? 'deep-orange' : 'primary'" label small class="me-1">
                                        <v-icon class="me-1">mdi-file</v-icon>
                                        {{attachment.meta.extension.toUpperCase()}}
                                    </v-chip>
                                    <v-chip label small class="ltr-dir">
                                        {{attachment.size}}
                                    </v-chip>
                                </v-list-item-subtitle>
                            </v-list-item-content>
                            <v-list-item-icon>
                                <v-btn as="a" icon color="primary" @mousedown.stop @mouseover.stop @touchstart.stop @click.stop :href="attachment.url">
                                    <v-icon size="22">mdi-download</v-icon>
                                </v-btn>
                                <v-btn icon color="error" @mousedown.stop @mouseover.stop @touchstart.stop @click.stop="openDeleteAttachmentDialog(attachment)">
                                    <v-icon size="22">mdi-close-circle-outline</v-icon>
                                </v-btn>
                            </v-list-item-icon>
                        </v-list-item>

                        <v-divider v-if="i < lectureAttachments.length-1" :key="'divider-' + i"></v-divider>
                    </template>
                </v-list>

                <div v-else class="py-2">
                    <v-alert text type="info" color="blue-grey darken-1">
                        لا يوجد مُرفقات مرتبطة بهذه المحاضرة، أضف مُرفق اﻵن!
                    </v-alert>
                </div>
            </v-card-text>
        </v-card>

        <div v-if="purchases" class="mb-4">
            <purchases-table :purchases="{data: lecturePurchases}" title="آخر عمليات الشراء" title-icon="mdi-order-bool-descending-variant" :all-href="`/purchases/lectures?query=lecture:${id}`" >
                <template slot="header-actions">
                    <template v-if="lectureData.course.pay_type === 'lectures'">
                        <v-btn depressed color="success" class="px-4" @click="addPurchaseDialog = true">
                            <v-icon :left="pcOnly">mdi-account-plus</v-icon>
                            <span v-if="pcOnly">إضافة عملية شراء</span>
                        </v-btn>
                    </template>
                </template>

            </purchases-table> <!-- :all-href="`/purchases?query=lecture:${id}`"  -->
        </div>

        <action-dialog v-model="addPurchaseDialog" action="post" :url="`/lectures/${id}/purchases`" success-msg="تم إضافة عملية الشراء بنجاح" title="إضافة عملية شراء للمحاضرة" subtitle="إضافة المحاضرة إلى مشتريات طالب مباشرة" button-text="إضافة" button-color="success darken-1" :data="addPurchaseForm" @reset="resetPurchaseForm" @sync="addToPurchases">
            <v-text-field v-model="addPurchaseForm.user" color="success darken-1" prepend-inner-icon="mdi-account-circle" label="حساب الطالب" placeholder="أدخل معرف الطالب أو البريد الإلكتروني"></v-text-field>
            <v-text-field v-model="addPurchaseForm.paid_value" color="success darken-1" prepend-inner-icon="mdi-cash" label="المبلغ المدفوع" placeholder="المبلغ الذي دفعه الطالب"></v-text-field>
        </action-dialog>

        <action-dialog v-model="addExamsDialog" action="post" :url="`/lectures/${id}/exams`" success-msg="تم إضافة الامتحان للمحاضرة بنجاح" title="إضافة امتحان للمحاضرة" subtitle="" button-text="إضافة" :data="addExam" @reset="resetAddExam" @sync="addToExams">
            <v-select v-model="addExam.exam_id" label="الامتحان" placeholder="اختر الامتحان من القائمة" :items="examsSelectItems"></v-select>
            <v-checkbox v-model="addExam.must_take" :disabled="!addExam.exam_id" label="دخول الامتحان مطلوب" color="primary" hide-details class="mb-3"></v-checkbox>
            <v-checkbox v-model="addExam.must_pass" :disabled="!addExam.exam_id" label="النجاح مطلوب" color="primary" hide-details class="mb-3"></v-checkbox>

            <v-expand-transition>
                <v-checkbox v-if="addExam.must_pass" v-model="showAlternativeExam" label="امتحان بديل في حالة الرسوب" color="primary" hide-details class="mb-3"></v-checkbox>
            </v-expand-transition>
            <v-expand-transition>
                <v-autocomplete v-if="showAlternativeExam" v-model="addExam.alternative_exam_id" clearable label="الامتحان البديل" persistent-hint hint="سيتوجب على الطالب النجاح في الامتحان البديل إن رسب في الامتحان اﻷساسي" :items="examsSelectItems.filter(e=>e.value !== addExam.exam_id)"></v-autocomplete>
            </v-expand-transition>
        </action-dialog>

        <action-dialog v-model="addAttachmentDialog" action="post" :url="`/lectures/${id}/attachments`" success-msg="تم إضافة المُرفق بنجاح" title="إضافة مُرفق للمحاضرة" subtitle="" button-text="إضافة" :data="addAttachmentForm"  :as-form-data="true" @reset="resetAttachmentForm" @sync="addToAttachments">
            <v-text-field v-model="addAttachmentForm.name" label="اسم المُرفق" placeholder="اكتب الاسم الذي سيظهر به المُرفق"></v-text-field>
            <v-file-input v-model="addAttachmentForm.file" ref="imageInput" placeholder="اختر ملف" prepend-icon="" prepend-inner-icon="mdi-attachment" hide-details label="الملف" ></v-file-input>
        </action-dialog>

        <action-dialog v-model="editExamsDialog" action="put" :url="`/lectures/${id}/exams`" success-msg="تم حفظ التغييرات بنجاح" title="تعديل إعدادات الامتحان" subtitle="" button-text="حفظ" :data="editedExam" @reset="resetAddExam" @sync="syncExamItem">
            <!-- <v-select v-model="addExam.exam_id" label="الامتحان" placeholder="اختر الامتحان من القائمة" :items="examsSelectItems"></v-select> -->
            <v-checkbox v-model="editedExam.must_take" label="دخول الامتحان مطلوب" color="primary" hide-details class="mb-3"></v-checkbox>
            <v-checkbox v-model="editedExam.must_pass" label="النجاح مطلوب" color="primary" hide-details class="mb-5"></v-checkbox>
            <v-autocomplete v-model="editedExam.alternative_exam_id" clearable label="الامتحان البديل (اختياري)" persistent-hint hint="سيتوجب على الطالب النجاح في الامتحان البديل إن رسب في الامتحان اﻷساسي" :items="examsSelectItems.filter(e=>e.value !== editedExam.exam_id)"></v-autocomplete>
        </action-dialog>

        <action-dialog v-model="removeExamDialog" action="delete" :url="`/lectures/${id}/exams/${removeExam ? removeExam.id : ''}`" title="إزالة الامتحان" button-text="تأكيد الحذف" button-color="error" @sync="removeExamItem(removeExam.id)">
            <div v-if="removeExam">
                <p class="strong-text--text mb-0">
                    هل أنت متأكد من إزالة الامتحان <b class="strong-text--text">"{{removeExam.name}}"</b> من المحاضرة؟
                </p>
            </div>
        </action-dialog>

        <action-dialog v-model="deleteAttachmentDialog" action="delete" :url="`/attachments/${deleteAttachment ? deleteAttachment.id : ''}`" title="حذف المُرفَق" button-text="تأكيد الحذف" button-color="error" @sync="removeAttachmentItem(deleteAttachment.id)">
            <div v-if="deleteAttachment">
                <p class="strong-text--text mb-0">
                    هل أنت متأكد من إزالة المرفق <b class="strong-text--text">"{{deleteAttachment.name}}"</b> من المحاضرة؟
                </p>
            </div>
        </action-dialog>


        <v-dialog v-if="purchases" v-model="exportAbsentUsersDialog" max-width="320" overlay-color="#000" overlay-opacity="0.8">
            <v-card>
                <v-card-title class="strong-text--text mb-1">
                    <v-icon color="green darken-2" right>mdi-file-export-outline</v-icon>
                    استخراج غياب الطلاب
                </v-card-title>
                <v-card-subtitle>استخراج بيانات الطلاب إلى ملف إكسيل</v-card-subtitle>
                <v-card-text>
                    <!-- <v-form class="mb-4">
                        <v-checkbox v-model="exportUserFullData" color="success" label="استخراج بيانات الطالب كاملة" persistent-hint hint="استخراج بيانات الطالب كاملةً وليس الاسم فقط" class="mt-0"></v-checkbox>
                    </v-form> -->
                </v-card-text>
                <v-card-actions class="pt-0 pb-3">
                    <form method="POST" :action="`${apiUrl}/lectures/${id}/absent/export`" class="w-100">
                        <input type="hidden" name="api_token" :value="apiToken" />

                        <v-btn type="submit" block color="green darken-1" depressed dark download @click="exportAbsentUsersDialog = false">
                            <v-icon left>mdi-download</v-icon>
                            استخراج الملف
                        </v-btn>
                    </form>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import CrudTable from '@/components/default/crud-table'
import StatCard from '@/components/default/stat-card'

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
import Videos from './Videos'
import PurchasesTable from '@/components/custom/purchases-table'

export default {
    components: {
        CrudTable,
        StatCard,
        Videos,
        PurchasesTable
    },
    props: {
        lecture: {},
        videos: {},
        exams: {},
        attachments: {},
        purchases: {},
        exams_select_items: {},
        stats: {},
    },
    data() {
        return {
            lectureData: null,
            lectureExams: null,
            lectureAttachments: null,

            lecturePurchases: null,

            addExamsDialog: false,

            exportAbsentUsersDialog: false,

            showAlternativeExam: false,
            addExam: {
                exam_id: '',
                must_take: false,
                must_pass: false,
                alternative_exam_id: '',
            },

            addPurchaseDialog: false,
            addPurchaseForm: {
                user: '',
                paid_value: '',
            },

            addAttachmentDialog: false,
            addAttachmentForm: {
                name: '',
                file: null,
            },

            editExamsDialog: false,
            editedExam: {
                exam_id: '',
                must_take: false,
                must_pass: false,
                alternative_exam_id: '',
            },

            removeExamDialog: false,
            removeExam: null,

            deleteAttachmentDialog: false,
            deleteAttachment: null,
        }
    },
    computed: {
        apiUrl(){
            return process.env.VUE_APP_API_URL;
        },
        apiToken(){
            return window.localStorage.getItem('tK');
        },
        id(){
            return this.lectureData.id;
        },
        page_url(){
            return '/lectures/' + this.lectureData.id;
        },
        examsSelectItems(){
            if (this.exams_select_items){
                return this.exams_select_items.filter(exam=>{
                    return !this.lectureExams.find(e=>e.id === exam.id);
                }).map(exam=>{
                    return {text: exam.name, value: exam.id};
                })
            }
            return [];
        },
        ...GlobalComputed,
    },
    watch: {
        addExam: {
            deep: true,
            handler(data){
                if (data.must_pass && !data.must_take){
                    data.must_take = true;
                }
            }
        }
    },
    methods: {
        ...GlobalMethods,
        sync(data){
            Object.assign(this.lectureData, data);
        },
        loadMore(page){
            this.$emit('loadMore', page);
        },
        addToExams(exam){
            this.lectureExams.push(exam);
        },
        addToPurchases(purchase){
            this.lecturePurchases.unshift(purchase);
        },
        addToAttachments(attachment){
            this.lectureAttachments.push(attachment);
        },
        syncExamItem(newItem){
            this.lectureExams = this.lectureExams.map(item=>{
                if (item.id === newItem.id){
                    return Object.assign(item, newItem);
                }
                return item;
            })
        },
        removeExamItem(id){
            this.lectureExams = this.lectureExams.filter(item=>{
                return item.id !== id;
            })
        },
        resetAddExam(){
            Object.assign(this.addExam, {
                exam_id: '',
                must_take: false,
                must_pass: false,
                alternative_exam_id: '',
            });
        },
        resetAttachmentForm(){
            Object.assign(this.addAttachmentForm, {
                name: '',
                file: null,
            });
        },
        resetPurchaseForm(){
            Object.assign(this.addPurchaseForm, {
                user: '',
            });
        },
        openEditExamDialog(exam){
            let data = {
                exam_id: exam.id,
                must_pass: exam.must_pass,
                must_take: exam.must_take,
                alternative_exam_id: exam.alternative_exam_id,
            };
            Object.assign(this.editedExam, data);
            this.editExamsDialog = true;
        },
        openRemoveExamDialog(exam){
            this.removeExam = exam;
            this.removeExamDialog = true;
        },
        openDeleteAttachmentDialog(attachment){
            this.deleteAttachment = attachment;
            this.deleteAttachmentDialog = true;
        },
        removeAttachmentItem(id){
            this.lectureAttachments = this.lectureAttachments.filter(item=>{
                return item.id !== id;
            })
        }
    },
    created(){
        this.lectureData = this.lecture.data;
        this.lectureExams = this.exams && this.exams.data ? this.exams.data : [];
        this.lectureAttachments = this.attachments && this.attachments.data ? this.attachments.data : [];
        this.lecturePurchases = this.purchases && this.purchases.data ? this.purchases.data : [];
    }
}

</script>
